// ── value_body preview: request building + response mapping (pure) ───────
// POST /pipelines/{id}/expr-preview, kind "value_body". The server answer is
// authoritative; this only shapes it for the editor.

export const ROW_CAP = 200;
export const ROW_LIST = 20;

export function buildValueBodyRequest({ src, rows, columns, outputs }) {
  return {
    src,
    kind: 'value_body',
    rows: (rows || []).slice(0, ROW_CAP),
    availableColumns: columns,
    outputs: [...outputs],
  };
}

const PROBLEM_TITLES = {
  rowErrors: 'Errors',
  noReturn: 'Returned nothing',
  badReturn: 'Not a plain value',
  unknownOutput: 'Unknown output key',
};
const PROBLEM_HINTS = {
  rowErrors: 'output left blank',
  noReturn: 'all outputs left blank',
  badReturn: 'that cell left blank',
  unknownOutput: 'key ignored',
};

export function show(v) {
  return v === null || v === undefined || v === '' ? null : String(v);
}

// Everything the preview panel renders, from one response.
export function mapValueBodyResponse(resp, rows, outputs, { listRows = ROW_LIST } = {}) {
  if (!resp || !Array.isArray(resp.values)) return null;
  const refCols = (resp.columns || []).slice(0, 6);
  const flagged = new Set();
  const problems = [];
  for (const key of ['rowErrors', 'noReturn', 'badReturn', 'unknownOutput']) {
    const p = resp[key];
    if (p && p.count > 0) {
      (p.examples || []).forEach(e => flagged.add(e.row));
      problems.push({ key, title: PROBLEM_TITLES[key], hint: PROBLEM_HINTS[key], count: p.count, examples: p.examples || [] });
    }
  }
  const n = Math.min(listRows, resp.values.length);
  const table = [];
  for (let i = 0; i < n; i++) {
    table.push({
      row: i + 1,
      refs: refCols.map(c => show(rows?.[i]?.[c])),
      values: outputs.map(o => show(resp.values[i]?.[o])),
      flagged: flagged.has(i + 1),
    });
  }
  const perOutput = outputs.map(o => ({
    name: o,
    blank: resp.blank?.[o] ?? 0,
    top: (resp.valueCounts?.[o] || []).slice(0, 5),
  }));
  return {
    headline: `Computed ${resp.total} row${resp.total === 1 ? '' : 's'}`,
    truncatedNote: resp.truncated ? `Showing the first ${resp.rowCap ?? resp.total} rows` : null,
    listNote: resp.total > n ? `Showing the first ${n} of ${resp.total} rows` : null,
    refCols, outputs: [...outputs], table, perOutput, problems,
    staticWarnings: (resp.warnings || []).map(w => ({
      code: w.code, message: w.message,
      where: w.line != null ? `line ${w.line}, column ${w.col ?? 1}` : null,
    })),
  };
}
